export const customErrorsList = ['5', '17', '18', '19', '20', '47', 'serverIsNotAvailable']
